import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from 'emailjs-com';

const Quote = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    helpText: '',
    marketingConsent: false,
    partnerConsent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  const Navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
  
    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      company: formData.company,
      country: formData.country,
      helpText: formData.helpText,
    };
  
    emailjs.send(
      'service_vdwgoas',     // e.g., 'service_xyz'
      'template_1b1665v',    // e.g., 'template_abc'
      templateParams,
      'ej0xoYJf3P2iUFKKO'      // e.g., 'user_xxx'
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      alert('Quote submitted successfully!');
      Navigate('/');
    })
    .catch((err) => {
      console.error('FAILED...', err);
      alert('Failed to submit quote. Please try again.');
    });
  };

  const countries = [
    'Afghanistan', 'Albania', 'Algeria', 'Australia', 'Austria', 'Bangladesh', 'Belgium', 'Brazil', 'Canada', 'China',
    'Egypt', 'France', 'Germany', 'India', 'Indonesia', 'Iran', 'Iraq', 'Italy', 'Japan', 'Kenya', 'South Korea',
    'Lebanon', 'Malaysia', 'Mexico', 'Morocco', 'Netherlands', 'Nigeria', 'Norway', 'Pakistan', 'Philippines',
    'Portugal', 'Russia', 'Saudi Arabia', 'South Africa', 'Spain', 'Sri Lanka', 'Sweden', 'Switzerland', 'Thailand',
    'Turkey', 'United Kingdom', 'United States', 'Venezuela', 'Vietnam', 'Zambia', 'Zimbabwe'
  ];

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-[#015d81] to-[#02394a] flex items-center justify-center">
      <div className="w-full max-w-md bg-white px-10 py-8 rounded-lg shadow-2xl shadow-gray-800 transition duration-300 transform hover:shadow-xl">
        <div className="flex justify-center mb-6">
          <img src="logo.png" alt="Company Logo" className="h-20 w-20" />
        </div>
        <p className="text-center text-md mb-6 text-gray-700 font-semibold">
          Request a customized quote
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          />
          <input
            type="email"
            name="email"
            placeholder="Company Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          />
          <input
            type="text"
            name="company"
            placeholder="Company"
            value={formData.company}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          />
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>

          <div className="text-sm text-gray-700">
            <label className="block mb-2">
              <input
                type="checkbox"
                name="partnerConsent"
                checked={formData.partnerConsent}
                onChange={handleChange}
                required
                className="mr-2"
              />
              Drobot may share my name and business contact info with authorized business partners or corporate affiliates.
            </label>
            <label>
              <input
                type="checkbox"
                name="marketingConsent"
                checked={formData.marketingConsent}
                onChange={handleChange}
                required
                className="mr-2"
              />
              Drobot may track my name and business contact info to email me for marketing purposes.
            </label>
          </div>

          <textarea
            name="helpText"
            placeholder="Please tell us how we can help you"
            value={formData.helpText}
            onChange={handleChange}
            required
            className="block w-full border border-gray-300 rounded-md px-3 py-2"
          ></textarea>

          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full bg-blue-500 text-white rounded-full py-2 px-4 font-semibold"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Quote;
